import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

import Formsy from 'formsy-react';
import { omit } from 'lodash';
import moment from 'moment';
import { Row, Col, Button, Input as PureInput, Label, FormGroup, FormBody, DefaultSheet, SheetBody, Select, FormCard, FormFooter, SheetFooter, DefaultTooltip, Badge, Separator, AlertDescription, SimpleAlert } from 'twyne-new.ui';

import CodeEditor from '@/components/form/CodeEditor';
import InfoTip from '@/components/InfoTip';
import InputSearchList from '@/components/InputSearchList';
import { useGlobalStore } from '@/stores/global';
import { useAppAlert } from '@Components/AppAlert';
import { useStatusForm } from '@Components/form/context';
import { FormFragment } from '@Components/formsy/FormComponent';
import TwyneURLForm from '@Components/formsy/TwyneURL';
import { buttonLabels } from '@Components/rules/options';
import app from '@Stores/app';
import Input from 'components/form/Input';
import Switch from 'components/form/Switch';
import InputFormsy from 'components/formsy/Input';
import { ValidatorComp } from 'components/rules/RuleItemValidator';
import history from 'utils/history';

import PathPagesList from '../../pages/components/PagePaths';
import { PageProvider } from '../../pages/store';
import { usePathStore } from '../store';

import PathPagesRulesForm from './PathPagesRulesForm';
import PageFilters from './sortable/PageFilters';
import PagesPallete from './sortable/PagesPallete';
import Slots from './sortable/Slots';
import SortablePagesLegacy from './sortable/SortablePagesLegacy';

class PathForm extends React.Component {
  rulesFormRef = React.createRef()

  state = {
    pages: [],
    pathpages: [],
    page2ListPaths: null,
    collapsedCards: {},
    pageFilters: {},
    filterParam: "",
    slots: [],
    slotsChanged: false,
    originalSlotsPositions: {},
    meta: {},
    rulesEnableSave: false,
    rulesConflictEvent: null,
    integrationDataParsed: {
      optimize: true,
    },
  };

  componentWillMount() {
    const { data } = this.props;
    if (data) {
      data.pathpages = data.pages || []

      if (data.integrationDataParsed?.optimize) {
        data.originalSlotsPositions = data.slots?.reduce((acc, slot, index) => {
          acc[slot.id] = index
          return acc
        }, {}) || {}
      }

      data.pid = data.integrationDataParsed?.pid;
      data.sid = data.integrationDataParsed?.sid;
      data.twyurl = data.integrationDataParsed?.twyurl;
      data.tcpaEnabled = !!data.integrationDataParsed?.twyurl
      data.fraudEnabled = data.integrationDataParsed?.fraudEnabled ?? false
      data.fraudConfig = data.integrationDataParsed?.fraudConfig

      this.setState(data);
    }
  }

  handleValidSubmit = model => {
    const state = omit(this.state, ["collapsedCards", "fetchedPages", "filter", "filteredPages", "pathpages", "unusedPages"])
    model.pages = state.pages;

    if (this.state.integrationDataParsed?.optimize) {
      model.slots = this.state.slots.map((slot, index) => {
        const slotIndex = this.state.originalSlotsPositions[slot.id]

        slot.isReset = slot.optimize?.experiment && slotIndex !== index

        if (slot.optimize?.experiment && (slot.isReset || slot.isManualReset || !slot.optimize?.startedDate)) {
          slot.optimize.startedDate = moment().utc()
        }
        return slot
      })
    }

    if (typeof model.integration_data === 'string') {
      model.integration_data = JSON.parse(model.integration_data)
    }

    model.integration_data = {
      ...this.state.integrationDataParsed,
      ...model.integration_data,
    }

    const hasTcpaPage = this.state.integrationDataParsed?.optimize ? this.state.slots.some(slot => slot.pages.some(page => page && page.type.startsWith("tcpa"))) : this.state.pages.some(page => page && page.type.startsWith("tcpa"))

    if (!this.state.tcpaEnabled || !hasTcpaPage) {
      delete model.integration_data.twyurl
      delete model.integration_data.pid
      delete model.integration_data.sid
    }

    model.integration_data.fraudEnabled = this.state.fraudEnabled

    if (this.state.fraudConfig?.apiKey) {
      model.integration_data.fraudConfig = this.state.fraudConfig
    }

    this.props.handleSubmit(Object.assign(state, model));
  }

  handleSetTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  handleChangeFilters = state => {
    this.setState(state)
  }

  renderTcpa = () => {
    const showTcpa = this.state.integrationDataParsed?.optimize ? this.state.slots.some(({ pages }) => pages.some(page => page && page.type.startsWith("tcpa"))) : this.state.pages.some(page => page && page.type.startsWith("tcpa"))
    if (!showTcpa) {
      return null
    }

    return (
      <Col>
        <FormCard title='TCPA Configuration' headerButtons={<div className='flex items-center gap-2'>
          <Switch
            name="tcpaEnabled"
            value={this.state.tcpaEnabled}
            onChange={tcpaEnabled => this.setState({ tcpaEnabled })}
          />
          <Label className='text-base twy-text-base'>Enabled</Label>
        </div>}>
          {this.state.tcpaEnabled && <>
            <FormFragment name="integration_data" >
              <Row>
                <Col size="12">
                  <Row hidden={!this.state.tcpaEnabled}>
                    <Col size="6">
                      <FormGroup>
                        <Label>Twyne Client</Label>
                        <TwyneURLForm
                          name="twyurl"
                          value={this.state.tcpaEnabled ? this.state.twyurl : ''}
                          required={this.state.tcpaEnabled}
                          disabled={!this.state.tcpaEnabled}
                        />
                      </FormGroup>
                    </Col>
                    <Col size="3">
                      <FormGroup>
                        <Label>PID</Label>
                        <InputFormsy
                          name="pid"
                          value={this.state.tcpaEnabled ? this.state.pid : ''}
                          required={this.state.tcpaEnabled}
                          disabled={!this.state.tcpaEnabled}
                        />
                      </FormGroup>
                    </Col>
                    <Col size="3">
                      <FormGroup>
                        <Label>Source ID</Label>
                        <InputFormsy
                          name="sid"
                          value={this.state.tcpaEnabled ? this.state.sid : ''}
                          required={this.state.tcpaEnabled}
                          disabled={!this.state.tcpaEnabled}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormFragment>
          </>}
        </FormCard>
      </Col>
    )
  }

  handleToogleCollapseCard = card => () => {
    this.setState(({ collapsedCards }) => {
      collapsedCards[card] = !collapsedCards[card]
      return { collapsedCards }
    })
  }

  PathPages = () => <>
    <span className='text-md twy-text-base-accent'>
      Is also visible in:
    </span>
    <PathPagesList pageId={this.state.page2ListPaths.id} />
  </>

  handleRulesStatusChange = ({ enableSave, conflictEvent }) => {
    this.setState({ rulesEnableSave: enableSave, rulesConflictEvent: conflictEvent })
  }

  onOpenValidatorModal = (path_pages, validatorId) => {
    const update = {
      validatorModalIsOpen: true,
      page2ListPaths: { ...this.state.page2ListPaths, path_pages },
    }

    if (validatorId) {
      update.validatorId = validatorId
    }

    this.setState(update)
  }

  onCloseValidatorModal = () => {
    this.setState({
      validatorModalIsOpen: false,
      validatorId: null,
    })
  }

  SelectDomain = () => {
    const { domain_aliases, viewdir } = app.site

    const domainsOptions = useMemo(() => domain_aliases.split(',').filter(domain => !domain?.includes('*')).map(domain => ({
      label: JSON.parse(domain),
      value: JSON.parse(domain),
    })), [domain_aliases])

    const changePageMeta = (page, option) => {
      page.path_pages.meta = {
        ...page.path_page?.meta,
        overrideDomain: option?.value || null,
      }

      return page
    }

    const handleChange = option => {
      this.setState(prev => {
        const { pages } = prev
        if (this.state.integrationDataParsed?.optimize) {
          return {
            slotsChanged: true,
            slots: this.state.slots.map(slot => {
              if (slot.id === slot.id) {
                return {
                  ...slot,
                  pages: slot.pages.map(page => page.id === this.state.page2ListPaths.id ? changePageMeta(page, option) : page),
                }
              }

              return slot
            }),
          }
        }

        return {
          pages: pages.map(page => {
            if (page.id === this.state.page2ListPaths.id) {
              page = changePageMeta(page, option)
            }

            return page
          }),
        }
      })
    }

    if (viewdir !== 'embed') return null

    if (!this.state.meta?.overrideDomain) return null

    if (!this.state.page2ListPaths.path_pages) return null

    if (this.state.integrationDataParsed?.optimize) {
      const slot = this.state.slots.find(slot => slot.pages.some(({ path_pages }) => path_pages.id === this.state.page2ListPaths.path_pages.id))
      if (slot?.sort === 0) return null
    }

    if (!this.state.integrationDataParsed?.optimize && this.state.page2ListPaths.path_pages?.sort === 0) return null

    return <Col size="6">
      <FormGroup>
        <Label>
          Domain
          <InfoTip>
            This config will override the domain for only this page.
          </InfoTip>
        </Label>
        <Select value={this.state.page2ListPaths?.path_pages?.meta?.overrideDomain} options={domainsOptions} onChange={handleChange} />
      </FormGroup>
    </Col>
  }

  RightSideBar = () => {
    const { updatePathPagesRules } = usePathStore()
    const { handleSuccess, handleError } = useAppAlert()
    const { rulesEnableSave, rulesConflictEvent } = this.state
    const disableForm = rulesConflictEvent === 'conflict' || rulesConflictEvent === 'checking'

    const handleClose = () => this.setState({ page2ListPaths: null, collapsedCards: { pathpages: false } })

    if (this.state.validatorModalIsOpen) {
      return <ValidatorComp
        validatorId={this.state.validatorId}
        onSubmit={() => this.onCloseValidatorModal()}
        onCancel={() => this.onCloseValidatorModal()}
      />
    }

    const handleSubmit = async () => {
      try {
        const rulesForm = this.rulesFormRef.current
        const { path_pages } = this.state.page2ListPaths
        path_pages.rules = rulesForm.state.rules
        if (!rulesForm.state.overridden) {
          path_pages.rules = null
        }
        await updatePathPagesRules(path_pages)
        handleSuccess('Succcess', "The rules has been updated")
        this.rulesFormRef.current?.setState({ enableSave: false })
      } catch (error) {
        handleError('Internal error', "Nothing has been changed")
      }
    }

    return <PageProvider>
      <DefaultSheet
        key={this.state.page2ListPaths.id}
        trigger={<></>}
        title={<div>Page <Link className='twy-text-accent' to={`/path/pages/${this.state.page2ListPaths.id}`}>{`[#${this.state.page2ListPaths.id}] ${this.state.page2ListPaths.name}`}</Link></div>}
        wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }}
      >
        <Formsy onValidSubmit={handleSubmit}>
          <SheetBody>
            <this.SelectDomain />
            <div className='flex flex-col gap-2'>
              <this.PathPages />
              <PathPagesRulesForm
                ref={this.rulesFormRef}
                pageData={this.state.page2ListPaths}
                onStatusChange={this.handleRulesStatusChange}
                onOpenValidatorModal={this.onOpenValidatorModal}
              />
            </div>
          </SheetBody>
          <SheetFooter>
            <Button onClick={() => handleClose()} variant='ghost'>Cancel</Button>
            <DefaultTooltip content={disableForm && "You can't save the override with rules conflict!"} triggerProps={{ asChild: true }}>
              <Button type='submit' color='accent' disabled={!rulesEnableSave || disableForm}>
                {buttonLabels[rulesConflictEvent] || 'Save'}
              </Button>
            </DefaultTooltip>
          </SheetFooter>
        </Formsy>
      </DefaultSheet>
    </PageProvider>
  }

  FormWrapper = ({ children }) => {
    const { handleStatus } = useStatusForm()
    return <Formsy onValidSubmit={this.handleValidSubmit} onChange={() => handleStatus({ hasChange: true })} >
      <FormBody>
        {children}
      </FormBody>
    </Formsy>
  }

  FraudHeaderButtons = () => <>
    <Switch
      name="fraudEnabled"
      value={this.state.fraudEnabled}
      onChange={fraudEnabled => this.setState({ fraudEnabled })}
    />
  </>

  FraudSection = () => {
    const { siteSettings: { getSystemConfig } } = useGlobalStore()
    const ezangaApiKey = getSystemConfig('ezanga.ezanga_api_key')

    return <FormCard title='Fraud Detection' headerButtons={<this.FraudHeaderButtons />}>
      {this.state.fraudEnabled && <>
        {ezangaApiKey && <SimpleAlert variant='warning' className='mt-0'>
        <p>
          The Anura API Key is inherited from the system settings and we will use the result from registration to update the fraud detection on this path.
        </p>
      </SimpleAlert>}
      <FormGroup>
        <Label>
          Anura.io API Key
          {!ezangaApiKey && <InfoTip>
            We will use this key to make fraud detection on this path. When you set this key and enable the fraud detection, we will call the Anura API on the first slot viewed and update the sessions on this path with the result from anura script.
          </InfoTip>}
        </Label>
        <PureInput
          value={ezangaApiKey || this.state.fraudConfig?.apiKey || ''}
          disabled={!!ezangaApiKey || !this.state.fraudEnabled}
          onChange={ezangaApiKey ? undefined : ({ target: { value } }) => this.setState({ fraudConfig: { apiKey: value } })}
        />
      </FormGroup>
      </>}
    </FormCard>
  }

  render() {
    return (
      <div>
        <this.FormWrapper>
          <Row>
            <Col>
              <FormCard title='General'>
                <Row>
                  <Col size="4">
                    <FormGroup>
                      <Label>Name</Label>
                      <Input name="name" value={this.state.name || ''} required />
                    </FormGroup>
                  </Col>
                  <Col size="3">
                    <FormGroup>
                      <Label>Title</Label>
                      <Input name="title" value={this.state.title || ''} required />
                    </FormGroup>
                  </Col>
                  <Col size="3">
                    <FormGroup>
                      <Label className='flex items-center gap-1'>
                        Redirect URL
                        <InfoTip>
                          When using the CMS this <strong>redirect URL</strong> could be an existing route or slug.<br />(e.g., <i>/deals/post1</i>, <i>/offer/post2</i>).
                          <br /><br />
                          Page variables are allowed here.<br />(e.g.: <i>/slug?session={'{usersessionid}'}</i>)
                        </InfoTip>
                      </Label>
                      <Input name="rurl" value={this.state.rurl || ''} />
                    </FormGroup>
                  </Col>
                  {app.site.viewdir === 'embed' && <Col size="2">
                    <FormGroup>
                      <Label>Domain override</Label>
                      <Switch name="meta.overrideDomain" value={this.state.meta?.overrideDomain ?? false} onChange={() => this.setState({ meta: { ...this.state.meta, overrideDomain: !this.state.meta?.overrideDomain } })} />
                    </FormGroup>
                  </Col>}
                </Row>
              </FormCard>
            </Col>
            <Col>
              <FormCard title='Pages' classNameBody='border-t twy-border-base'>
                <Row className='gap-0'>
                  {this.state.integrationDataParsed?.optimize ? <this.Pages /> : <this.PagesLegacy />}
                </Row>
              </FormCard>
            </Col>
            <Col>
              <FormCard title='Content'>
                <CodeEditor
                  resizable
                  name="content"
                  value={this.state.content || ''}
                  width="100%"
                  height="200px"
                />
              </FormCard>
            </Col>
            <Col>
              <this.FraudSection />
            </Col>
            {/* {this.renderTcpa()} */}
          </Row>
          <FormFooter>
            <Button type="submit" color="accent">Save</Button>
            <Button onClick={() => history.goBack()} variant='ghost'>Cancel</Button>
          </FormFooter>
        </this.FormWrapper>
        {this.state.page2ListPaths && <this.RightSideBar />}
      </div >
    );
  }

  PagesLegacy = () => {
    const { pages, filterParam, pageFilters } = this.state
    const [filteredPages, setFilteredPages] = useState([])
    const [unusedPages, setUnusedPages] = useState([])
    const [filter, setFilter] = useState('')
    const totalFiltersApllyed = Object.keys(pageFilters).length

    const { lists: { pages: { items: fetchedPages, useLoad } } } = usePathStore()
    const params = useMemo(() => ({ term: filterParam }), [filterParam])
    useLoad(params)

    useEffect(() => {
      let unusedPages = fetchedPages;

      if (pages && pages.length) {
        for (const page of pages) {
          unusedPages = unusedPages.filter(item => item.id !== page.id)
        }
      }

      setUnusedPages(unusedPages)
    }, [fetchedPages, pages])

    const filterPages = useCallback(() => {
      let filteredPages = unusedPages

      if (filter.trim().length) {
        filteredPages = filteredPages.filter(page => page.id.toString().includes(filter) || page.name.toUpperCase().includes(filter.toUpperCase()))
      }

      setFilteredPages(filteredPages)
    }, [filter, unusedPages])

    useEffect(() => {
      filterPages()
    }, [filterPages])

    const handleRemove = page => {
      this.setState(({ pages }) => ({
        pages: pages.filter(pageState => pageState.id !== page.id),
      }))
    }

    const handleDropLast = ({ draggedItem: { data, node } }) => {
      this.setState(({ pages }) => {
        if (pages.some(pageState => pageState.id === data.id)) {
          pages.splice(pages.length - 1, 0, pages.splice(node.index, 1)[0])
          return {
            pages: [...pages],
          }
        }
        pages.push(data)
        return {
          pages: [...pages],
        }
      })
    }

    const handleMovePage = ({ draggedItem: { node, data } }, { to: { index: targetIndex } }) => {
      this.setState(({ pages }) => {
        pages.splice(node.index < targetIndex ? targetIndex - 1 : targetIndex, 0, node === 'available' ? data : pages.splice(node.index, 1)[0]);
        return {
          pages: [...pages],
        }
      });
    }

    const handleReorderPages = pages => {
      this.setState({ pages });
    }

    return <>
      <Col size="4">
        <InputSearchList
          className='flex justify-between gap-2 mr-4'
          placeholder="Pages"
          value={filter || ''}
          onChange={setFilter}>
          <div className='flex items-center gap-2'>
            <Badge color='accent' variant='outline' className='self-center'>
              {totalFiltersApllyed}
            </Badge>
            <PageFilters onChangeFilters={this.handleChangeFilters} filters={this.state.pageFilters} />
          </div>
        </InputSearchList>
        <div className='pr-4'>
          <Separator className='my-2 mx-0' />
        </div>
        <PagesPallete
          items={filteredPages}
          onChange={page => {
            setFilteredPages(pages => {
              if (pages.some(pageState => pageState.id === page.id)) return pages
              return [page, ...pages]
            });
            handleRemove(page)
          }}
          scrollable
        />
      </Col>
      <Col size="8" className='border-l twy-border-base'>
        <SortablePagesLegacy
          items={pages}
          onClick={page2ListPaths => this.setState({ page2ListPaths })}
          onMove={handleMovePage}
          onDropLast={handleDropLast}
          onRemove={handleRemove}
          onReorder={handleReorderPages}
        />
      </Col>
    </>
  }

  Pages = () => {
    const { filterParam, pageFilters, slots, slotsChanged } = this.state
    const [filteredPages, setFilteredPages] = useState([])
    const [filter, setFilter] = useState('')
    const totalFiltersApllyed = Object.keys(pageFilters).length

    const { lists: { pages: { items: fetchedPages, useLoad } } } = usePathStore()
    const params = useMemo(() => ({ term: filterParam }), [filterParam])
    useLoad(params)

    const { handleStatus } = useStatusForm()

    useEffect(() => {
      handleStatus({ hasChange: slotsChanged })
    }, [handleStatus, slotsChanged])

    const filterPages = useCallback(() => {
      let filteredPages = fetchedPages

      if (filter.trim().length) {
        filteredPages = filteredPages.filter(page => page.id.toString().includes(filter) || page.name.toUpperCase().includes(filter.toUpperCase()))
      }

      setFilteredPages(filteredPages)
    }, [filter, fetchedPages])

    useEffect(() => {
      filterPages()
    }, [filterPages])

    const handleRemoveFromSlot = ({ pageId, slotIndex }) => {
      this.setState(({ slots }) => {
        const slot = slots[slotIndex]
        slot.pages = slot.pages.filter(page => page.id !== pageId)

        if (slot.pages.length === 0) {
          slots.splice(slotIndex, 1)
        }

        return {
          slots: [...slots],
          slotsChanged: true,
        }
      })
    }

    const handleRemoveSlot = slotIndex => {
      this.setState(({ slots }) => {
        slots.splice(slotIndex, 1)
        return {
          slots: [...slots],
          slotsChanged: true,
        }
      })
    }

    const handleDropLast = ({ draggedItem }, { to }) => {
      const isAvailable = draggedItem.node === 'available'
      if (!isAvailable && handleMoveDifferentSlot(draggedItem, { ...to, isLast: true })) return

      this.setState(({ slots }) => {
        const { node, data } = draggedItem
        const { slotIndex } = to
        const slot = slots[slotIndex] || {}
        const { pages } = slot
        const alredyExists = pages.some(pageState => pageState.id === data.id)

        if (isAvailable && alredyExists) return {}

        if (pages && alredyExists) {
          pages.splice(pages.length - 1, 0, pages.splice(node?.index, 1)[0])
          slot.pages = [...pages]
        } else {
          pages.push(data)
          slot.pages = [...pages]
        }

        slots[node?.slotIndex] = slot

        return {
          slots: [...slots],
          slotsChanged: true,
        }
      })
    }

    const handleDropLastSlot = ({ draggedItem }) => {
      this.setState(({ slots }) => {
        const { data, node } = draggedItem
        if (data.pages) {
          const [slotMoved] = slots.splice(node.slotIndex, 1)

          slots.push(slotMoved);
          return {
            slots: [...slots],
            slotsChanged: true,
          }
        }
        const { slotIndex, index } = node

        slots[slotIndex] && slots[slotIndex].pages.splice(index, 1)

        return {
          slots: [...slots, { pages: [data] }],
          slotsChanged: true,
        }
      })
    }

    const handleMoveDifferentSlot = (draggedItem, to) => {
      const { slotIndex: slotIndexSource, index: indexSource } = draggedItem.node
      const { slotIndex: slotIndexTarget, index: indexTarget, isLast } = to

      if (slotIndexSource === slotIndexTarget) return false

      this.setState(({ slots }) => {
        const slotSource = slots[slotIndexSource]
        const slotTarget = slots[slotIndexTarget] || { pages: [] }

        const { pages: pagesSource } = slotSource
        const { pages: pagesTarget } = slotTarget

        if (pagesTarget.some(page => page.id === pagesSource[indexSource].id)) return {}

        if (isLast) {
          pagesTarget.push(pagesSource.splice(indexSource, 1)[0])
        } else {
          pagesTarget.splice(indexTarget, 0, pagesSource.splice(indexSource, 1)[0])
        }

        slotSource.pages = pagesSource
        slotTarget.pages = pagesTarget

        slots[slotIndexSource] = slotSource
        slots[slotIndexTarget] = slotTarget

        if (slotSource.pages.length === 0) {
          slots.splice(slotIndexSource, 1)
        }

        return {
          slots: [...slots],
          slotsChanged: true,
        }
      })

      return true
    }

    const handleMovePage = ({ draggedItem }, { to }) => {
      const { data, node } = draggedItem
      const { index: targetIndex, slotIndex } = to
      const isAvailable = node === 'available'

      if (!isAvailable && handleMoveDifferentSlot(draggedItem, to)) return

      this.setState(({ slots }) => {
        const slot = slots[slotIndex] || {}
        const { pages = [] } = slot

        if (isAvailable && pages.some(page => page.id === data.id)) return {}

        pages.splice(node?.index < targetIndex ? targetIndex - 1 : targetIndex, 0, isAvailable ? data : pages.splice(node.index, 1)[0])

        slot.pages = pages
        if (slots[slotIndex]) {
          slots[slotIndex] = slot
        } else {
          slots.push(slot)
        }

        return {
          slots: [...slots],
          slotsChanged: true,
        }
      })
    }

    const handleReorderSlotPages = (slotIndex, pages) => {
      this.setState(({ slots }) => {
        const next = [...slots]
        const slot = next[slotIndex]
        if (!slot) return {}
        next[slotIndex] = { ...slot, pages }
        return {
          slots: next,
          slotsChanged: true,
        }
      })
    }

    const handleReorderSlots = reorderedSlots => {
      this.setState({
        slots: reorderedSlots,
        slotsChanged: true,
      })
    }

    const handleMoveSlot = ({ draggedItem }, { to }) => {
      const { data, node } = draggedItem
      const { slotIndex: slotIndexSource } = node
      const { slotIndex: slotIndexTarget } = to

      const isSlot = !!data?.pages

      if (!isSlot) {
        this.setState(({ slots }) => {
          slots[slotIndexSource] && slots[slotIndexSource].pages.splice(node.index, 1)

          slots.splice(slotIndexTarget, 0, { pages: [data] })

          return {
            slots: [...slots],
            slotsChanged: true,
          }
        })

        return
      }

      this.setState(({ slots }) => {
        const newData = isSlot ? data : { pages: [data] }
        slots.splice(slotIndexSource < slotIndexTarget ? slotIndexTarget - 1 : slotIndexTarget, 0, node === 'available' || (slotIndexTarget === 0 && slotIndexSource === undefined) ? newData : slots.splice(slotIndexSource, 1)[0]);
        return {
          slots: [...slots],
          slotsChanged: true,
        }
      })
    }

    const handleChangeSlot = ({ data, key, slotIndex }) => {
      this.setState(({ slots }) => {
        slots[slotIndex][key] = data
        const isReset = key === 'isManualReset' && data
        return {
          slots: [...slots],
          slotsChanged: ['optimize'].includes(key) || isReset,
        }
      })
    }

    return <>
      <Col size="4">
        <InputSearchList
          className='flex justify-between gap-2 mr-4'
          placeholder="Pages"
          value={filter || ''}
          onChange={setFilter}>
          <div className='flex items-center gap-2'>
            <Badge color='accent' variant='outline' className='self-center'>
              {totalFiltersApllyed}
            </Badge>
            <PageFilters onChangeFilters={this.handleChangeFilters} filters={this.state.pageFilters} />
          </div>
        </InputSearchList>
        <div className='pr-4'>
          <Separator className='my-2 mx-0' />
        </div>
        <PagesPallete
          items={filteredPages}
          onChange={page => {
            setFilteredPages(pages => {
              if (pages.some(pageState => pageState.id === page.id)) return pages
              return [page, ...pages]
            });
          }}
          scrollable
        />
      </Col>
      <Col size="8" className='h-[calc(100vh-29.8rem)] overflow-y-auto overflow-x-hidden pl-4 border-l twy-border-base'>
        <div className='-mt-2'>
          <Slots
            slots={slots}
            originalSlotsPositions={this.state.originalSlotsPositions}
            onClick={page2ListPaths => this.setState({ page2ListPaths })}
            onMove={handleMovePage}
            onMoveSlot={handleMoveSlot}
            onDropLast={handleDropLast}
            onDropLastSlot={handleDropLastSlot}
            onRemove={handleRemoveFromSlot}
            onRemoveSlot={handleRemoveSlot}
            onChangeSlot={handleChangeSlot}
            onReorderPages={handleReorderSlotPages}
            onReorderSlots={handleReorderSlots}
          />
        </div>
      </Col>
    </>
  }
}

PathForm.propTypes = {
  handleSubmit: PropTypes.func,
  data: PropTypes.any,
};

export default PathForm;
